<template>
  <div>
    <NavigationTop
      title="Bank Details"
      description="Make sure that the account holder's First Name and Last Name match exactly with the bank account details. Please check with your bank if any other information is required for transfer. If yes, add it under Additional Bank Details."
      canceltext="Back"
      cancelurl="provide-information"
    />
    <BankDetailsForm
      v-if="form"
      ref="form"
      :claim-id="$store.state.claim.id"
      :form="form"
    />
    <NavigationBottom nextpagetext="Continue" nextpageurl="summary" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import NavigationTop from '@/components/Common/Navigation/NavigationButtons/NavigationTop.vue';
import NavigationBottom from '@/components/Common/Navigation/NavigationButtons/NavigationBottom.vue';

import BankDetailsForm from '@/components/Form/BankDetails.vue';

export default {
  name: 'BankDetails',
  components: {
    BankDetailsForm,
    NavigationTop,
    NavigationBottom
  },
  computed: {
    ...mapState({ form: (state) => state.form.bankDetails })
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === 'summary') {
      const { $v } = this.$refs.form;

      $v.$touch();

      if (!$v.$invalid) {
        next();
      }
    } else {
      next();
    }
  },
  mounted() {
    this.$store.commit('SET_PROGRESS', 'bank-details');
  }
};
</script>
